/**
 * Maps the selected Sizing filter to the `sizing_passed` query parameter.
 *
 * SDCP-1321: "pending" is the state the sizing tool marks when a project does not pass and needs
 * manual review. The option used to be sent as "submitted", which the backend resolved through a
 * different definition and returned the wrong set.
 */
export const getSizingPassedFilter = (
  sizingFilters: string[]
): "passed" | "failed" | "pending" | undefined => {
  if (sizingFilters.includes("passed")) return "passed";
  if (sizingFilters.includes("failed")) return "failed";
  if (sizingFilters.includes("pending")) return "pending";
  return undefined;
};

export default getSizingPassedFilter;
